//@ts-check 
import cleanPath from './cleanPath';
import isFolder from './isFolder';

var removeTrailingSlash = function removeTrailingSlash(path) {
  if (path.endsWith('/')) return path.substring(0, path.length - 1);else return path;
};
/**
 * @type {import("./types").getFolderPathType}
 */


export default (function (path) {
  var filePath = cleanPath(path); //nothing?

  if (!filePath) return ''; //already a folder?

  if (isFolder(path)) return removeTrailingSlash(path); //file path

  var segments = filePath.split('/');
  segments.pop();
  return segments.join('/');
});